import { useAppContext } from "../../../AppProvider";

export const useListProps = () => {
  const { dictionary } = useAppContext();
  return {
    path: `/registry-service/email-notification-events`,
    banner: {
      enabled: false,
    },
    defaultPagination: {
      page: 0,
      size: 200,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "creationDate",
        isDefault: true,
      },
    ],
    title: <h3>{dictionary.notifications.event_list}</h3>,
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    pagination: { enabled: false },
  };
};
